import axios from '@/http/axios'

export function getAccounts () {
  return axios({
    url: 'v1/accountancy/accounts',
    method: 'get'
  })
}

export function insertAccount (payload) {
  return axios({
    url: 'v1/accountancy/accounts',
    data: payload,
    method: 'post'
  })
}

export function editAccount (id, payload) {
  return axios.patch(`v1/accountancy/accounts/${id}`, payload)
}

export function deleteAccount (id) {
  return axios({
    url: `v1/accountancy/accounts/${id}`,
    method: 'delete'
  })
}
